export default __webpack_public_path__ + "static/media/actividad-22.71c4fcdc.mp3";